import React from 'react';
import { FormFieldTypes } from './form-field-config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  IconDefinition,
  faCheck,
  faEye,
  faEyeSlash,
} from '@fortawesome/free-solid-svg-icons';
import {
  faEye as faEyeThin,
  faEyeSlash as faEyeSlashThin,
} from '@fortawesome/pro-thin-svg-icons';
import { isFunction, ProjectTypes } from '@r-and-a-shared-ui/utils';

export interface FormFieldIconParams {
  fieldHasError?: boolean;
  value?: string;
  toggleShowPassword?: (...args: unknown[]) => unknown;
  showPassword?: boolean;
  className?: string;
  hideIcon?: boolean;
  projectType?: ProjectTypes;
}

const isValidEmail = (email?: string) => {
  if (!email) return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const formFieldIcons: Record<
  FormFieldTypes,
  (params: FormFieldIconParams) => React.JSX.Element | undefined
> = {
  text: () => undefined,
  email: params => {
    if (params?.fieldHasError || params?.hideIcon) return undefined;

    if (!params?.value) return undefined;

    if (!isValidEmail(params.value)) return undefined;

    return (
      <FontAwesomeIcon
        className={`${params?.className}`}
        icon={faCheck}
        size="xl"
      />
    );
  },
  password: params => {
    if (params?.hideIcon) {
      return undefined;
    }

    const isPlayerPortals = params?.projectType === ProjectTypes.PlayerPortals;
    const icon: IconDefinition = params?.showPassword
      ? isPlayerPortals
        ? faEyeThin
        : faEye
      : isPlayerPortals
      ? faEyeSlashThin
      : faEyeSlash;

    const handleOnClick = () => {
      if (isFunction(params?.toggleShowPassword)) {
        params?.toggleShowPassword();
      }
    };

    return (
      <FontAwesomeIcon
        className={`${params?.className}`}
        icon={icon}
        size={isPlayerPortals ? 'lg' : 'xl'}
        onClick={handleOnClick}
      />
    );
  },
  password_confirmation: () => undefined,
  dropdown: () => undefined,
  pp_dropdown: () => undefined,
  dropdowns_group: () => undefined,
  dropdown_with_other: () => undefined,
  radio_buttons: () => undefined,
  checkboxes: () => undefined,
  number: () => undefined,
  phone_number: () => undefined,
  country: () => undefined,
  favorite_player: () => undefined,
  date: () => undefined,
  mastercard: () => undefined,
  undefined: () => undefined,
  one_club_free_text: () => undefined,
  password_with_confirm_and_multiple_validation: () => undefined,
  hidden_field_with_value: () => undefined,
  numbered_checkboxes: () => undefined,
  numbered_checkboxes_with_other: () => undefined,
  attachment: () => undefined,
};
